import { generateColors, getDistinctValues } from "src/utils/arrayUtils"

export const cmaps = {
    "Sleep_Code": {
        'Active Waking': [221, 241, 246],
        'Quiet Waking': [221, 241, 246],
        'HV Slow Wave Sleep': [131, 183, 200],
        'LV Slow Wave Sleep': [160, 247, 224],
        'Certain REM Sleep': [255, 240, 145],
        "Putative REM Sleep": [255, 240, 145],
        'Drowsiness': [221, 241, 246],
        'Unscorable': [0, 0, 0]
    },
    "Simple_Sleep_Code": {
        'Active Waking': [221, 241, 246],
        'Quiet Waking': [221, 241, 246],
        'SWS': [131, 183, 200],
        'LV Slow Wave Sleep': [160, 247, 224],
        'REM': [255, 240, 145],
        "Putative REM Sleep": [255, 240, 145],
        'Drowsiness': [221, 241, 246],
        'Unscorable': [0, 0, 0]
    }
}

export function SAFE_getCmap(data, key) {
    if (Object.keys(cmaps).includes(key)) return cmaps[key]
    const distinct_classes = getDistinctValues(data, key)
    return generateColors(distinct_classes)
}